var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginAsAlertBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 65,
    viewBox: "0 0 375 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-371 0H-319L-257.25 65H-309.25L-371 0Z",
    fill: "#596E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 0H71L132.75 65H80.75L19 0Z",
    fill: "#596E91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M409 0H461L522.75 65H470.75L409 0Z",
    fill: "#596E91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M799 0H851L912.75 65H860.75L799 0Z",
    fill: "#596E91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-176 0H-124L-62.25 65H-114.25L-176 0Z",
    fill: "#596E91"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214 0H266L327.75 65H275.75L214 0Z",
    fill: "#596E91"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M604 0H656L717.75 65H665.75L604 0Z",
    fill: "#596E91"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M994 0H1046L1107.75 65H1055.75L994 0Z",
    fill: "#596E91"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-273.5 0H-221.5L-159.75 65H-211.75L-273.5 0Z",
    fill: "#596E91"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 0H168.5L230.25 65H178.25L116.5 0Z",
    fill: "#596E91"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M506.5 0H558.5L620.25 65H568.25L506.5 0Z",
    fill: "#596E91"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M896.5 0H948.5L1010.25 65H958.25L896.5 0Z",
    fill: "#596E91"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-78.5 0H-26.5L35.25 65H-16.75L-78.5 0Z",
    fill: "#596E91"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M311.5 0H363.5L425.25 65H373.25L311.5 0Z",
    fill: "#596E91"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M701.5 0H753.5L815.25 65H763.25L701.5 0Z",
    fill: "#596E91"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.5 0H1143.5L1205.25 65H1153.25L1091.5 0Z",
    fill: "#596E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginAsAlertBg);
export default __webpack_public_path__ + "static/media/LoginAsAlertBg.f6490695e9709e9934b2e379468dc102.svg";
export { ForwardRef as ReactComponent };